"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _slider = _interopRequireDefault(require("@ux/slider"));
var _utils = require("@site/utils");
var _TermLengthSlider = require("./styles/TermLengthSlider");
var _reactMintl = require("@godaddy/react-mintl");
var _classnames = _interopRequireDefault(require("classnames"));
const TermLengthSlider = ({
  id = 'term-length-slider',
  additionalClassNames = '',
  termsArray,
  minTerm = termsArray?.[0],
  maxTerm = termsArray?.[termsArray?.length - 1],
  selectedTerm,
  setSelectedTerm,
  ariaLabels,
  rangeIndicatorsLabelId
}) => {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const hasTermsArray = termsArray && termsArray.length > 0;
  const {
    min,
    max,
    defaultValue
  } = hasTermsArray ? {
    min: 0,
    max: termsArray.length - 1,
    defaultValue: termsArray.findIndex(item => item === selectedTerm)
  } : {
    min: minTerm,
    max: maxTerm,
    defaultValue: selectedTerm
  };
  const getRangeIndicatorsLabel = termValue => rangeIndicatorsLabelId ? formatMessage({
    id: rangeIndicatorsLabelId
  }, {
    termValue
  }) : termValue;
  const handleChange = selectedItem => {
    setSelectedTerm(hasTermsArray ? termsArray[selectedItem] : selectedItem);
  };
  return /*#__PURE__*/_react.default.createElement(_TermLengthSlider.TermLengthSliderStyle, null, /*#__PURE__*/_react.default.createElement(_slider.default, {
    id: id,
    className: (0, _classnames.default)('term-length-slider mb-3 px-2', additionalClassNames),
    min: min,
    max: max,
    defaultValue: defaultValue,
    onChange: handleChange,
    ariaLabels: ariaLabels,
    rangeIndicators: [getRangeIndicatorsLabel(minTerm), getRangeIndicatorsLabel(maxTerm)],
    rtl: _utils.MarketHelper.isRtlMarket(),
    hideTooltip: true,
    discrete: true
  }));
};
var _default = exports.default = TermLengthSlider;